<template>
    <div>
        <section class="flex flex-col w-full">
            <h1 class="w-full p-2 bg-aitems-700 text-gray-100 font-light tracking-wide">
                {{ trans.get('items.lista_tipi_articolo') }}
            </h1>
            <div class="flex w-full p-4 justify-end">
                <open-modal modal="add-item-type">
                    {{ trans.get('items.aggiungi_tipo_articolo') }}
                </open-modal>
            </div>
        </section>

        <section class="w-3/4 table mx-auto rounded border shadow-lg">
            <div class="th tr">
                <div class="td">
                    {{ trans.get('items.tipo_parte') }}

                </div>
                <div class="td" style="flex-grow: 2">
                    {{ trans.get('items.descrizione') }}
                </div>
            </div>
            <section>
                <div class="row"
                     v-for="(item, index) in items"
                     :key="item.id"
                >
                    <div class="tr">
                        <div class="td uppercase">
                            <editable-cell-input :id="item.id"
                                                 :data="item.p_r_classe_e"
                                                 :field="'p_r_classe_e'"
                                                 :url="url"
                                                 @data-has-changed="onDataHasChanged"
                            >
                            </editable-cell-input>
                        </div>
                        <div class="td" style="flex-grow: 2">
                            <editable-cell-input :id="item.id"
                                                 :data="item.descrizione"
                                                 :field="'descrizione'"
                                                 :url="url"
                                                 @data-has-changed="onDataHasChanged"
                            >
                            </editable-cell-input>
                        </div>
                    </div>
                </div>
            </section>
        </section>


        <modal name="add-item-type" height="auto" transition="slide" :clickToClose="false">
            <div class="flex flex-col">

                <div class="w-full flex justify-between items-center py-3 px-1 bg-aitems-700 text-gray-100 mb-6">
                    <div class="font-bold tracking-wide p-2 pl-6 uppercase">{{
                        trans.get('items.aggiungi_tipo_articolo_header') }}
                    </div>
                    <div class="font-bold p-2 cursor-pointer"
                         @click="$modal.hide('add-item-type')">
                        <i class="fas fa-times-circle"></i>
                    </div>
                </div>

                <item-type-creator @item_type_has_been_created="onItemTypeCreated"></item-type-creator>

            </div>
        </modal>

    </div>
</template>

<script>

    import ItemTypeCreator from './ItemTypeCreator.vue';
    import EditableCellInput from './EditableCellInput';
    import openModal from './buttons/openModal';

    export default {

        data() {
            return {
                items: {},
                isActive: false,
                url: '/item_types/translations/'
            }
        },

        components: {
            ItemTypeCreator,
            EditableCellInput,
            openModal,
        },

        created() {
            axios.get('/item_types')
                .then(({data}) => {
                    this.items = data
                })
        },

        methods: {

            toggleItemCreator() {
                this.isActive = !this.isActive;
            },

            onItemTypeCreated(item) {
                this.items.push(item);
                this.$modal.hide('add-item-type');
            },

            onDataHasChanged() {
                console.log('Ricevuto!')
            }

        }

    }
</script>

